import { Component, EventEmitter, Input, Output } from "@angular/core";
import { Subject } from "rxjs";

@Component({
  selector: "app-number-control",
  templateUrl: "./number-control.component.html",
  styleUrls: ["./number-control.component.scss"],
})
export class NumberControlComponent {
  @Input() controlName: string;
  @Input() count: number;
  @Input() disabled: boolean;
  @Output() countChange: EventEmitter<number> = new EventEmitter<number>();

  constructor() {}

  incrementControl() {
    this.countChange.next(this.count);

    this.countChange.emit(this.count + 1);
  }

  decrementControl() {
    if (this.count == 0) return;

    this.countChange.emit(this.count - 1);
  }
}
